module.exports = __webpack_public_path__ + "static/media/iland.74175c1e.png";